import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../provider/AuthProvider";
import { useInstalledApps } from "../provider/InstalledAppsProvider";

export const ProtectedRoute = ({ allowedGroups, requiredApp }) => {
  const { token, userdetails, isAuthLoading } = useAuth();
  const { isAppInstalled, isAppsLoading } = useInstalledApps();

  // Auth state is still hydrating from localStorage on the first render tick.
  // Render nothing until it's stable — prevents false "no permission" redirects
  // that occur when group_names hasn't propagated to context consumers yet.
  if (isAuthLoading) {
    return null;
  }

  // Check if the user is authenticated
  if (!token) {
    // If not authenticated, redirect to the login page
    return <Navigate to="/login" />;
  }

  // A route that belongs to an installable module: wait for the installed
  // list, then keep people out of modules this tenant does not have.
  if (requiredApp) {
    if (isAppsLoading) return null;
    if (!isAppInstalled(requiredApp)) {
      return <Navigate to="/unauthorized" replace state={{ reason: 'module_not_installed', module: requiredApp }} />;
    }
  }

  // If allowedGroups is provided, check if the user has permission
  if (allowedGroups && !userdetails?.is_superuser) {
    const userGroups = userdetails?.group_names || [];
    const hasAccess = allowedGroups.some(group => userGroups.includes(group));

    if (!hasAccess) {
      // If unauthorized, redirect to the unauthorized page
      return <Navigate to="/unauthorized" replace />;
    }
  }

  // If authenticated and authorized, render the child routes
  return <Outlet />;
};
